import * as React from 'react';

import {
  useFeatures
} from 'src/providers';

import { Modal } from '../Modal';
import { SlideOut } from './SlideOut';
import { InterstitialTypes } from 'src/types/IModal';

export function Interstitial() {
  const { interstitialType } = useFeatures();

  const renderPrompt = () => {
    switch (interstitialType) {
      case InterstitialTypes.MODAL:
        return (
          <Modal />
        );
      case InterstitialTypes.SLIDEOUT:
      default:
        return (
          <SlideOut />
        );
    }
  };

  return renderPrompt();
}
